import React from 'react';
import PropTypes from 'prop-types';

export const InstagramIcon = ({ width }) => {
  return (
    <svg width={width} viewBox="0 0 170 170" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0)">
        <path
          d="M122.406 0H46.654C20.929 0 0 20.93 0 46.655V122.407C0 148.133 20.929 169.062 46.654 169.062H122.406C148.133 169.062 169.062 148.132 169.062 122.407V46.655C169.063 20.93 148.133 0 122.406 0ZM154.063 122.407C154.063 139.862 139.862 154.062 122.407 154.062H46.654C29.2 154.063 15 139.862 15 122.407V46.655C15 29.201 29.2 15 46.654 15H122.406C139.861 15 154.062 29.201 154.062 46.655V122.407H154.063Z"
          fill="white"
        />
        <path
          d="M84.531 40.97C60.51 40.97 40.968 60.512 40.968 84.533C40.968 108.553 60.51 128.094 84.531 128.094C108.552 128.094 128.094 108.553 128.094 84.533C128.094 60.512 108.552 40.97 84.531 40.97ZM84.531 113.093C68.782 113.093 55.968 100.281 55.968 84.532C55.968 68.782 68.781 55.969 84.531 55.969C100.281 55.969 113.094 68.782 113.094 84.532C113.094 100.281 100.28 113.093 84.531 113.093Z"
          fill="white"
        />
        <path
          d="M129.921 28.251C127.031 28.251 124.192 29.421 122.151 31.471C120.1 33.511 118.921 36.351 118.921 39.251C118.921 42.142 120.101 44.981 122.151 47.031C124.191 49.071 127.031 50.251 129.921 50.251C132.821 50.251 135.651 49.071 137.701 47.031C139.751 44.981 140.921 42.141 140.921 39.251C140.921 36.351 139.751 33.511 137.701 31.471C135.661 29.421 132.821 28.251 129.921 28.251Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="169.063" height="169.063" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

InstagramIcon.propTypes = {
  width: PropTypes.string, //24
};
InstagramIcon.defaultProps = {
  width: '30px',
};
